import 'react';
import 'prop-types';
import '../types/props.js';
import { css } from 'reakit/styled';
import { palette, theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import { a as Icon } from '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import Button from '../Button/index.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import '../Pane/index.js';
import '../Text/styled.js';
import '../Text/index.js';
import '../Card/styled.js';
import CardCard from '../Card/CardCard.js';
import CardHeader from '../Card/CardHeader.js';
import CardContent from '../Card/CardContent.js';
import CardTitle from '../Card/CardTitle.js';
import CardFooter from '../Card/CardFooter.js';

var getTintAttributes = function getTintAttributes(props) {
  var type = props.type,
      hasTint = props.hasTint;

  if (!hasTint || !type) {
    return;
  }

  return css(["background-color:", ";color:", ";fill:", ";", ";"], type && palette(type + "Tint")(props), type && palette(type + "TintInverted")(props), type && palette(type + "TintInverted")(props), theme('fannypack.Callout.tint'));
};
var Callout = styled(CardCard).withConfig({
  displayName: "styled__Callout",
  componentId: "sc-578c22-0"
})(["position:relative;", ";&{", ";}"], getTintAttributes, theme('fannypack.Callout.base'));
var CalloutClose = styled(Button).withConfig({
  displayName: "styled__CalloutClose",
  componentId: "sc-578c22-1"
})(["position:absolute;right:1rem;top:1rem;width:1.5em;min-height:1.5em;padding:0;text-align:right;&:hover{background-color:", ";&{", ";}}", ";"], palette('white700'), theme('fannypack.Callout.Close.hover'), theme('fannypack.Callout.Close.base'));
var CalloutHeader = styled(CardHeader).withConfig({
  displayName: "styled__CalloutHeader",
  componentId: "sc-578c22-2"
})(["display:flex;justify-content:flex-start;&{", ";}"], theme('fannypack.Callout.Header.base'));
var CalloutContent = styled(CardContent).withConfig({
  displayName: "styled__CalloutContent",
  componentId: "sc-578c22-3"
})(["&{", ";}"], theme('fannypack.Callout.Content.base'));
var CalloutTitle = styled(CardTitle).withConfig({
  displayName: "styled__CalloutTitle",
  componentId: "sc-578c22-4"
})(["&{", ";}"], theme('fannypack.Callout.Title.base'));
var CalloutFooter = styled(CardFooter).withConfig({
  displayName: "styled__CalloutFooter",
  componentId: "sc-578c22-5"
})(["&{", ";}"], theme('fannypack.Callout.Footer.base'));
var CalloutIcon = styled(Icon).withConfig({
  displayName: "styled__CalloutIcon",
  componentId: "sc-578c22-6"
})(["margin-right:", "rem;&{", ";}"], space(4), theme('fannypack.Callout.Icon.base'));

export default Callout;
export { Callout, CalloutClose, CalloutContent, CalloutFooter, CalloutHeader, CalloutIcon, CalloutTitle, getTintAttributes };
